module.exports = __webpack_public_path__ + "img/login-bg.741c03b5.png";